import { useAuth0 } from '@auth0/auth0-react';
import { useMe } from '../../api/queries';
import { tenantDisplay } from '../../lib/names';
import { shortId } from '../../lib/format';
import { shell } from '../../copy/shell';
import s from './NavFooter.module.css';

/**
 * Who you are and which tenant you are acting on.
 *
 * The email comes from the ID token, not from `/v1/me`: a default Auth0 setup puts no
 * profile claims in an *access* token, so `me.user.email` is null for most tenants while
 * the ID token has it. The tenant name and role come from rypt, because they are facts
 * about rypt.
 */
export function NavFooter() {
  const { user } = useAuth0();
  const me = useMe();

  const identity = user?.email ?? user?.name ?? (me.data ? shell.userId(shortId(me.data.user.id)) : null);

  return (
    <div className={s.footer}>
      {identity ? <span className={s.identity}>{identity}</span> : null}
      {me.data ? (
        <span className={s.tenant}>
          {`${tenantDisplay(me.data.tenant.name, user)} · ${me.data.role}`}
        </span>
      ) : (
        <span className={s.pending}>—</span>
      )}
    </div>
  );
}

export default NavFooter;
